import $ from "cash-dom";
import getCssVarValue from "./function_get-css-var-value";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    var selector = "[data-flip-image]";

    function toggleFlip($instance) {
        if (!$instance || !$instance.length) return;

        var $layout = $instance.parents(".layout");
        var $button = $layout.find("[data-flip]");

        $instance.toggleClass("on");
        $layout.find(".stack").children().toggleClass("on pointer-none");
        $button.find("svg").toggleClass("on");
    }

    function handleClick() {
        var $layout = $(this).parents(".layout");
        var $instance = $layout.find(selector);

        toggleFlip($instance);
    }

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_flip-image.js initialized", "green");

        var $button = $(selector).parents(".layout").find("[data-flip]");
        var delay = getCssVarValue("--duration-xl");

        $button.on("click", handleClick);

        $(selector).each(function () {
            var $instance = $(this);

            ScrollTrigger.create({
                trigger: $instance[0],
                start: "top bottom-=10%",
                endTrigger: "html",
                end: "bottom top",
                onEnter: function () {
                    setTimeout(function () {
                        toggleFlip($instance);
                    }, delay);
                },
            });
        });
    }

    $(document).ready(init);
})();
